import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {toJS} from "mobx";


import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
import Button from "../../components/CustomButtons/Button.jsx";
import IconCard from "../../components/Cards/IconCard";
import SweetAlert from "react-bootstrap-sweetalert";

import SettingsIcon from '@material-ui/icons/Settings';
import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import Divider from "material-ui/Divider/Divider";
import {v4 as uuidv4} from "uuid";
import {PHOTOSELFIE_BASE_URL} from "../../utils/constants";

import withStyles from "material-ui/styles/withStyles";
import configurationStyle from "../../assets/jss/material-dashboard-pro-react/layouts/configurationStyle";
import '../../assets/css/calendar-configuration.css';


import Cookies from "universal-cookie";

const cookies = new Cookies();


@inject('store')
@observer
class CalendarConfiguration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projectID: '',
            calendar_name: '',
            language: 'it',
            calendar_landing_page_url: '',
            calendar_created_ok: false,
            error_add_new_calendar: false
        }
        this.store = this.props.store.appState;
    }


    componentDidMount() {
        const project_id = cookies.get('project_id');
        const self = this;
        self.setState({projectID: project_id});
    }


    setLanguage = (event) => {
        const self = this;
        self.store.handle_app_lang(event.target.value);
        const lang = event.target.value;
        self.setState({
            text: lang,
            language: event.target.value
        })
    }

    generateCalendarUrl = () => {
        const calendar_unique_token = uuidv4().substr(0, 8);
        const calendar_landing_page_url = PHOTOSELFIE_BASE_URL + '/upload-calendar/' + calendar_unique_token;
        this.setState({
            calendar_landing_page_url: calendar_landing_page_url,
            error_add_new_calendar: false
        });
        this.store.selected_calendar_url = calendar_landing_page_url;
    }

    saveCalendar = () => {
        let self = this;
        const calendar_data = {
            calendar_id: self.store.selected_calendar_id,
            calendar_name: self.store.selected_calendar_name,
            calendar_language: self.state.language,
            calendar_landing_page_url: self.store.selected_calendar_url,
            projectID: self.state.projectID,
        }

        if (!self.store.selected_calendar_url.trim() || !self.store.selected_calendar_name.trim()) {
            self.setState({error_add_new_calendar: true});
            return;
        } else {
            self.store.saveNewCalendar(calendar_data, function (res) {
                
                if (res && res.code === 11) {
                    alert(res.message.toUpperCase());
                    return;
                }

                if (res) {
                    self.setState({
                        calendar_created_ok: true
                    });
                }
            })
        }

    }

    closeAddNewCalendar = () => {
        this.props.history.push({
            pathname: '/home-calendar'
        });
    }

    render() {
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        // const {language, calendar_landing_page_url, calendar_created_ok, error_add_new_calendar} = this.state;
        const { calendar_landing_page_url, calendar_created_ok, error_add_new_calendar} = this.state;
        const project_id = cookies.get('project_id');
        const project_name = cookies.get('project_name');
        return (
            <React.Fragment>
                <GridContainer justify='center'>
                    <ItemGrid xs={10} sm={10} md={10}><h2
                        style={{textAlign: "center"}}>{project_id} - {project_name}</h2></ItemGrid>
                    <ItemGrid xs={8} sm={8} md={8}>
                        <IconCard
                            icon={SettingsIcon}
                            iconColor="rose"
                            title={DEFAULT_TEXT.create_calendar.toUpperCase()}
                            content={
                                <div>
                                    <div className='flexbox-row-calendar'>
                                        <label>{DEFAULT_TEXT.calendar_name}<span
                                            className='required-input'>*</span></label>
                                        <input type='text' className='calendar-name-input'
                                               onChange={(event) => {
                                                   this.setState({
                                                       calendar_name: event.target.value,
                                                       error_add_new_calendar: false
                                                   })
                                                   this.store.selected_calendar_name = event.target.value;
                                               }}
                                               defaultValue={this.store.selected_calendar_name}
                                        />
                                    </div>

                                    <div className='flexbox-row-calendar'>
                                        <label>{DEFAULT_TEXT.cal_config_lang}
                                            <span className='required-input'>*</span>
                                        </label>
                                        <div id='select-language-calendar'>
                                            <Button style={{width: '218px', height: '2.5rem'}} color='purple' size='sm'
                                                    round>
                                                <Select
                                                    fullWidth={true}
                                                    value={this.store.lang || 'it'}
                                                    style={{color: "white"}}
                                                    onChange={(event) => this.setLanguage(event)}
                                                    disableUnderline={true}
                                                    inputProps={{name: "simpleSelect", id: "simple-select"}}>
                                                    <MenuItem value="it"><span className={'span-lang'}>Italiano </span></MenuItem>
                                                    <MenuItem value="en"><span className={'span-lang'}> English </span></MenuItem>
                                                    <MenuItem value="fr"><span className={'span-lang'}> Français</span></MenuItem>
                                                    <MenuItem value="de"><span
                                                        className={'span-lang'}> Deutsch</span></MenuItem>
                                                    <MenuItem value="es"><span
                                                        className={'span-lang'}> Español</span></MenuItem>
                                                </Select>
                                            </Button>
                                        </div>
                                    </div>

                                    <div className='flexbox-row-calendar'>
                                        <Button
                                            onClick={() => this.generateCalendarUrl()}
                                            color={this.store.selected_calendar_url !== '' ? 'primary' : 'purple'}
                                            round
                                            disabled={this.store.selected_calendar_url !== ''}
                                            style={{width: '218px', height: '2.5rem'}}
                                        >
                                            {DEFAULT_TEXT.genera_url}
                                        </Button>
                                        <div>
                                            <span
                                                className='calendar-url'>{calendar_landing_page_url || this.store.selected_calendar_url}</span>
                                            <Divider style={{width: '18rem'}}/>
                                        </div>
                                    </div>
                                    <div className='close-button-calendar'>
                                        <Button color={calendar_created_ok ? 'primary' : 'rose'} round
                                                onClick={calendar_created_ok ? () => this.closeAddNewCalendar() : () => this.saveCalendar()}>
                                            {calendar_created_ok ? 'chiudi'.toUpperCase() : 'salva'.toUpperCase()}
                                        </Button>
                                    </div>
                                </div>
                            }
                        />
                        {
                            error_add_new_calendar
                                ?
                                <SweetAlert
                                    confirmBtnText='OK'
                                    warning
                                    confirmBtnStyle={{background: 'green'}}
                                    title=''
                                    onConfirm={() => {
                                        this.setState({error_add_new_calendar: false})
                                    }}
                                    confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                    {DEFAULT_TEXT.calendar_alert}
                                </SweetAlert>
                                : null
                        }
                    </ItemGrid>
                </GridContainer>
            </React.Fragment>
        )
    }
}

export default withStyles(configurationStyle)(CalendarConfiguration);



// WEBPACK FOOTER //
// ./src/views/Calendar/CalendarConfiguration.jsx